/* ==========================================================================
   ORW Collection Cards -- mobile scroll-snap pagination

   Only active at <= 749px (horizontal scroll-snap carousel layout).
   On tablet/desktop the section is a grid/row with no scroll, so the
   dots are hidden via CSS and this script exits early.
   ========================================================================== */

(function () {
  'use strict';

  var MOBILE_MQ = '(max-width: 749px)';

  function initSection(section) {
    var track = section.querySelector('[data-orw-collection-cards-track]');
    var dots = Array.prototype.slice.call(
      section.querySelectorAll('[data-orw-collection-cards-dot]')
    );
    if (!track || dots.length === 0) return;

    var cards = Array.prototype.slice.call(
      track.querySelectorAll('.orw-collection-card')
    );
    if (cards.length === 0) return;

    var mql = window.matchMedia(MOBILE_MQ);
    var scrollHandler = null;

    function setActive(index) {
      for (var i = 0; i < dots.length; i++) {
        var isActive = i === index;
        dots[i].classList.toggle('is-active', isActive);
        dots[i].setAttribute('aria-selected', isActive ? 'true' : 'false');
      }
    }

    function onScroll() {
      // Find the card whose left edge is closest to the track's scroll-start
      // (accounting for scroll-padding-inline-start = 16px).
      var trackRect = track.getBoundingClientRect();
      var anchorX = trackRect.left + 16;
      var closestIdx = 0;
      var closestDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var cardLeft = cards[i].getBoundingClientRect().left;
        var dist = Math.abs(cardLeft - anchorX);
        if (dist < closestDist) {
          closestDist = dist;
          closestIdx = i;
        }
      }
      setActive(closestIdx);
    }

    function scrollToIndex(index) {
      var card = cards[index];
      if (!card) return;
      var trackRect = track.getBoundingClientRect();
      var cardRect = card.getBoundingClientRect();
      var target = track.scrollLeft + (cardRect.left - trackRect.left) - 16;
      track.scrollTo({ left: target, behavior: 'smooth' });
    }

    function attachMobile() {
      if (scrollHandler) return;
      scrollHandler = onScroll;
      track.addEventListener('scroll', scrollHandler, { passive: true });
      for (var i = 0; i < dots.length; i++) {
        (function (idx) {
          dots[idx].addEventListener('click', function (e) {
            e.preventDefault();
            scrollToIndex(idx);
          });
        })(i);
      }
      onScroll();
    }

    function detachMobile() {
      if (!scrollHandler) return;
      track.removeEventListener('scroll', scrollHandler);
      scrollHandler = null;
    }

    function sync() {
      if (mql.matches) {
        attachMobile();
      } else {
        detachMobile();
        setActive(0);
      }
    }

    sync();

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', sync);
    } else if (typeof mql.addListener === 'function') {
      // Safari < 14 fallback
      mql.addListener(sync);
    }
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-orw-collection-cards]');
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
